/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * The tags in use on a store's customers, for the tag pickers in the settings dialog.
 * @export
 * @interface ShopifyCustomerTagsResponse
 */
export interface ShopifyCustomerTagsResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyCustomerTagsResponse
   */
  tags: Array<string>;
}

/**
 * Check if a given object implements the ShopifyCustomerTagsResponse interface.
 */
export function instanceOfShopifyCustomerTagsResponse(
  value: object,
): value is ShopifyCustomerTagsResponse {
  if (!("tags" in value) || value["tags"] === undefined) return false;
  return true;
}

export function ShopifyCustomerTagsResponseFromJSON(
  json: any,
): ShopifyCustomerTagsResponse {
  return ShopifyCustomerTagsResponseFromJSONTyped(json, false);
}

export function ShopifyCustomerTagsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyCustomerTagsResponse {
  if (json == null) {
    return json;
  }
  return {
    tags: json["tags"],
  };
}

export function ShopifyCustomerTagsResponseToJSON(
  json: any,
): ShopifyCustomerTagsResponse {
  return ShopifyCustomerTagsResponseToJSONTyped(json, false);
}

export function ShopifyCustomerTagsResponseToJSONTyped(
  value?: ShopifyCustomerTagsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    tags: value["tags"],
  };
}
